import { Map, fromJS } from 'immutable';
import { changeTouristData } from 'src/store/tourists/slice';
import * as ORDER from '../constants/order';
import { TOGGLE_FLIGHT_CLASS } from '../../CheckoutRoutes/PackageCheckout/store/flights/constants';
import {
  RESET_TOURIST_CONFIRMED,
  TOURISTS_VALIDATION_SUCCESS,
} from '../constants/tourists';
import { CLEAR_PREVIOUS_PACKAGE_DATA } from '../constants/similar-packages';

const initialState = Map();

export default function orderReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    // Flights:
    case TOGGLE_FLIGHT_CLASS:
    case ORDER.SELECT_FLIGHT: {
      const { flight_pair_id, extras, originalFlight } = payload;
      return state.withMutations((s) =>
        s
          .set('flight_pair_id', flight_pair_id)
          .set('flight_extras', fromJS(extras))
          .set('originalFlight', originalFlight),
      );
    }
    case ORDER.SKIP_FLIGHTS:
      return state.set('isSkipFlights', true);
    case ORDER.SET_FLIGHT_INFO:
      return state.set('flightInfo', fromJS(payload));

    // Client:
    case ORDER.CONFIRM_CLIENT:
      return state.set('isClientConfirmed', true);
    case ORDER.RESET_CLIENT:
      return state.set('isClientConfirmed', false);

    // Tourist:
    case TOURISTS_VALIDATION_SUCCESS:
      return state.set('isTouristsConfirmed', true);
    case changeTouristData.type:
    case RESET_TOURIST_CONFIRMED:
      return state.set('isTouristsConfirmed', false);

    // Order Comment:
    case ORDER.CHANGE_ORDER_COMMENT:
      return state.set('comment', fromJS(payload));
    case ORDER.SET_ORDERS_AMOUNT:
      return state.setIn(['jointOrder', 'ordersAmount'], payload);
    case ORDER.SET_FIRST_ORDER_NUMBER:
      return state.setIn(['jointOrder', 'firstOrderNumber'], payload);
    case ORDER.SWITCH_ORDER:
      return state.setIn(
        ['jointOrder', 'isFirstOrder'],
        !state.getIn(['jointOrder', 'isFirstOrder']),
      );
    case ORDER.SET_FIRST_ORDER_FIELD:
      return state.setIn(['jointOrder', 'isFirstOrder'], payload);

    // Preuild Order:
    case ORDER.PREBUILD_ORDER:
      return state.set('isPrebuildFetching', true);
    case ORDER.PREBUILD_ORDER_FAIL:
      return state.withMutations((s) =>
        s.set('isPrebuildFetching', false).set('errors', fromJS(payload)),
      );
    case ORDER.PREBUILD_ORDER_SUCCESS: {
      const {
        data: {
          order: {
            price_info,
            full_price,
            bonuses,
            coupon,
            discount_methods,
            discount_price,
            discount_type,
            insurance_price,
            order_extras,
          },
        },
      } = payload;
      return state.merge(
        fromJS({
          priceInfo: price_info,
          fullPrice: full_price,
          bonuses,
          coupon,
          discount_methods,
          discount_price,
          discount_type,
          order_extras,
          insurance_price,
          isPrebuildFetching: false,
          isPrebuilt: true,
          errors: null,
        }),
      );
    }
    case ORDER.PREBUILD_ORDER_COMPLETE_WITH_MINDBOX_ERRORS: {
      const {
        data: {
          order: {
            price_info,
            full_price,
            bonuses,
            coupon,
            discount_methods,
            discount_price,
            discount_type,
            insurance_price,
            order_extras,
          },
          order_errors,
        },
      } = payload;
      return state.merge(
        fromJS({
          priceInfo: price_info,
          fullPrice: full_price,
          bonuses,
          coupon,
          discount_methods,
          discount_price,
          discount_type,
          order_extras,
          insurance_price,
          isPrebuildFetching: false,
          isPrebuilt: true,
          errors: order_errors,
        }),
      );
    }
    case CLEAR_PREVIOUS_PACKAGE_DATA:
      return state.merge(
        fromJS({
          flight_pair_id: undefined,
          flight_extras: null,
          flightInfo: null,
          insuranceType: null,
          coupon: null,
          discount_price: null,
          discount_type: null,
          errors: null,
          priceInfo: null,
          comment: {
            text: '',
            checkboxes: ORDER.ORDER_COMMENT_CHECKBOXES,
          },
          jointOrder: {
            ordersAmount: 0,
            firstOrderNumber: 0,
            isFirstOrder: null,
          },
        }),
      );

    // Create Order:
    case ORDER.CREATE_ORDER:
      return state.set('isCreating', true);
    case ORDER.CREATE_ORDER_SUCCESS: {
      const {
        data: { id, secret_stamp: pin },
      } = payload;
      return state.merge(
        fromJS({
          id,
          pin,
          isCreated: true,
          isCreating: false,
        }),
      );
    }
    case ORDER.CREATE_ORDER_FAIL:
      return state.set('isCreating', false);

    // Update order:
    case ORDER.UPDATE_ORDER:
      return state.merge(fromJS(payload));
    case ORDER.UPDATE_ORDER_SUCCESS: {
      // TODO: думать, возможно что-то еще надо
      const { price_info, full_price, payment_methods } = action.payload;
      return state.merge(
        fromJS({
          priceInfo: price_info,
          fullPrice: full_price,
          payment_methods,
        }),
      );
    }
    case ORDER.SET_PAYLATE_DATA:
      return state.set('paylateData', payload);

    // Sub checks:
    case ORDER.STASH_USER_PRICE_BEFORE_PAY:
      return state.set('priceOnPay', payload);
    case ORDER.TOGGLE_INSURANCE: {
      const { hashsum, selected } = payload;
      return state.set('insuranceType', selected ? hashsum : null);
    }

    // Order process:
    case ORDER.ORDER_PROCESSED:
      return state.withMutations((s) =>
        s.set('isProcessed', true).set('isProcessing', false),
      );
    case ORDER.CONFIRM_ORDER:
      return state.set('priceOnPay', null);
    case ORDER.FINISH_ORDER:
      return state.set('isFinished', true);

    // Price change
    case ORDER.SET_PRICE_CHANGE: {
      const { priceChange } = payload;
      return state.set('priceChange', priceChange);
    }

    default:
      return state;
  }
}
